import { TranslationDictionary } from '@domgen/dgx-fe-i18n';
import { FeatureArticleSearchTranslationKeys } from './feature-article-search-translation-keys.type';

export type FeatureArticleSearchTranslationDictionary =
  TranslationDictionary<FeatureArticleSearchTranslationKeys>;
